const FONT_CACHE = {}

export const loadFont = (family) => {
  if (!family || FONT_CACHE[family]) {
    return
  }
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')
  style.type = 'text/css'
  const css = `@import url('https://fonts.googleapis.com/css?family=${family.replace(/\s/gi, '+')}');`
  style.appendChild(document.createTextNode(css))
  head.appendChild(style)
  FONT_CACHE[family] = true
}